import React from "react";
import { Button } from "../../../ui/button";
import { useNavigate, useParams } from "react-router-dom";
import Image from "../../../Tags/Image";
import { useTheme } from "../../../ThemeProvider";

export default function AccessDeniedView() {
  const navigate = useNavigate();
  const { workspaceSlug } = useParams();
  const { theme } = useTheme();

  const handleGoToDashboard = () => {
    navigate(`/${workspaceSlug}`);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] mx-auto">
      <div className="text-center">
        <div className="flex justify-center items-center mb-8">
          {theme === "dark" ? (
            <Image
              src="/images/icons/untitledui/call-logs/403-error-dark.svg"
              alt="Access denied"
              width={240}
              height={240}
              className="no-invert"
            />
          ) : (
            <Image
              src="/images/icons/untitledui/call-logs/403-error.svg"
              alt="Access denied"
              width={240}
              height={240}
            />
          )}
        </div>

        <h3 className="text-xl font-semibold text-[#414651] dark:text-white mb-2">Access Restricted</h3>
        <p className="text-[#475467] dark:text-gray-400 mb-8 max-w-lg mx-auto">
          You don't have permission to access call recordings. This feature may not be available in your
          current plan or your account may not have the necessary permissions.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleGoToDashboard} className="px-6">
            Go to Dashboard
          </Button>
          <Button
            variant="outline"
            onClick={() => window.open("mailto:support@primerole.com", "_blank")}
            className="px-6"
          >
            Contact Support
          </Button>
        </div>

        <p className="text-sm text-[#667085] dark:text-gray-500 mt-6">
          Need help? Reach out to us at{" "}
          <a
            href="mailto:support@primerole.com"
            className="text-[#9E77ED] hover:text-purple-800 dark:hover:text-purple-300 underline"
          >
            support@primerole.com
          </a>
        </p>
      </div>
    </div>
  );
}
